import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function deviceLoginApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.DeviceloginapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value: "https://demo-sop.jtfulfillment.cn/api/wms/device/auth/login"
          },
          {
            key: "apiDocDesc.proUrl",
            value: "https://sop.jtfulfillment.cn/api/wms/device/auth/login"
          },
          { key: "customerid:", value: "CS001" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/api/wms/device/auth/login"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value: "https://openapi.jtfulfillment.cn/api/wms/device/auth/login"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          { key: "warehouseCode:", value: "SH.001" },
          // { key: "itemCode:", value: "STZX0000001" },
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "Content-Type",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.desc499" 
            },
            {
              name: "X-DEVICE",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.desc500"
            },
            {
              name: "X-FN",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.desc501"
            },
            {
              name: "X-SN",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.desc502"
            },
            {
              name: "username",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.usenameDesc503"
            },
            {
              name: "password",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.passwordDesc504"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "code",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.codeDesc505"
            },
            {
              name: "msg",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.msgDesc506"
            },
            {
              name: "data",
              type: "OBJRCT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.dataDesc507",
              children: [
                {
                  name: "username",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.usernameDesc508"
                },
                {
                  name: "token",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.tokenDesc509"
                },
                {
                  name: "client",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.clientDesc510"
                },
                {
                  name: "defaultWarehouseCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.defaultWarehouseCodeDesc511"
                }
              ]
            },
            {
              name: "traceId",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.traceIdDesc512"
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        username: "UPFOS-TEST",
        password: "Password123!"
      },
      //返回示例
      responseCode: {
        code: "200",
        msg: "登录成功",
        data: {
          username: "UPFOS-TEST",
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
          client: "ANDROID_DEVICE_888",
          defaultWarehouseCode: "SH.001",
          traceId: "trace-20251209-abc123def456"
        }
      }
    }
  };
}
